"use strict";

define('app/print/letter/print.letter.controller',['app/print/abstract/print.abstract.controller', 'app/print/letter/print.letter.view', 'rs/models/document.letter'], function (AbstractContentController, PrintLetterView, DocumentLetter) {
  var PrintLetterController = AbstractContentController.extend({
    properties: ['content'],
    viewIsAvailable: function viewIsAvailable() {
      this.sync('content');
    },
    contentDidChange: function contentDidChange() {
      var view = this.getView();
      if (view && view.isAvailable()) {
        view.render(this.getContent());
      }
    },
    setupView: function setupView() {
      this.setView(new PrintLetterView());
    },
    start: function start(documentLetterId) {
      var view = this.getView(),
        that = this;
      return Promise.attempt(function () {
        if (documentLetterId != null) {
          return DocumentLetter.requestReplacedLetterContent(documentLetterId);
        } else {
          return that.getContent() || '';
        }
      }).then(function (content) {
        view.render(content);
        view.setRendered();
      });
    },
    getTemplateProperties: function getTemplateProperties() {}
  });
  return PrintLetterController;
});

